import * as C from '../constants';
import * as api from '../api';

export const receivedFAQ = (
  view: string,
  data: QuestionAnswer[]
): FAQReceivedAction => ({
  type: C.ACTION_TYPES.FAQ_RECEIVED,
  payload: {
    view,
    data,
  },
});

export const errorFetchFAQ = (): Action => ({
  type: C.ACTION_TYPES.FAQ_FETCH_ERROR,
});

export const fetchFAQ = () => async (
  dispatch: Function,
  getState: Function
) => {
  try {
    const data = await api.faq.getFAQ(C.VIEWS.PAYMENT);
    dispatch(receivedFAQ(C.VIEWS.PAYMENT, data));
  } catch (err) {
    dispatch(errorFetchFAQ());
  }
};



// WEBPACK FOOTER //
// ./app/actions/FAQActionCreators.ts